const emails = [
  {
    address: "stephaneboutinaffaires@gmail.com",
    label: "Contact & facturation clients",
  },
  {
    address: "information@stephane-boutin.com",
    label: "Publicité, événements & invitations",
  },
  {
    address: "soumissions@stephane-boutin.com",
    label: "Devis, collaborateurs & fournisseurs",
  },
  {
    address: "ventes@stephane-boutin.com",
    label: "Facturation & contrats clients",
  },
];

export default function Footer() {
  return (
    <footer>
      {/* Email Grid */}
      <div className="bg-gray-900 py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <p
            className="text-xs font-semibold tracking-widest uppercase text-amber-500 mb-10 text-center"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Nous contacter
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {emails.map((email) => (
              <a
                key={email.address}
                href={`mailto:${email.address}`}
                className="flex items-start gap-4 p-5 rounded-lg bg-gray-800/60 hover:bg-gray-800 transition-all duration-200 group cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-amber-500 text-xl" />
                </div>
                <div>
                  <p
                    className="text-white text-sm font-medium group-hover:text-amber-400 transition-colors duration-200"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {email.address}
                  </p>
                  <p
                    className="text-gray-400 text-xs mt-1"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {email.label}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-950 py-5 px-6">
        <p
          className="text-center text-gray-500 text-xs tracking-wide"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Copyright 2026, tous droits réservés — stephane-boutin.com
        </p>
      </div>
    </footer>
  );
}
